import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import ServiceProvider from './ServiceProvider';
import { ActionHistory } from 'material-ui/svg-icons';
import ServiceProvidersHistoryDialog from 'components/Regions/Port/ServiceProviders/ServiceProvidersHistoryDialog';
import { IconButton } from 'material-ui';

class ServiceProviders extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            openHistoryDialog: false,
            
        };
    }

    toggleHistoryDialog = () => {
        this.setState({
            openHistoryDialog: !this.state.openHistoryDialog,
        });
    }

    render() {
        const {
            serviceProviders, rejectServiceProvider, approveServiceProvider, port, 
        } = this.props;
        const { openHistoryDialog } = this.state;
        return (
            <Fragment>
                <div className="main__title row">
                    <div style={{ margin: '0' }} className="col-xs-11">
                    Service providers
                    </div>
                    <div className="col-xs-1">
                        <IconButton onClick={this.toggleHistoryDialog}>
                            <ActionHistory color="#B3B3B3" />
                        </IconButton>
                    </div>
                </div>

                <div className="service-providers">
                    <div className="table" style={{ margin: '0 0 70px 0' }}>
                        <div className="table-header">
                            <div className="table-row">
                                <div className="table-col">
                                    Activity
                                </div>
                                <div className="table-col">
                                    Company Name
                                </div>
                                <div className="table-col">
                                    Contact Details
                                </div>
                            </div>
                        </div>
                        <div className="table-body">
                            {
                                serviceProviders.map((serviceProvider, index) => (
                                    <ServiceProvider
                                        key={index}
                                        serviceProvider={serviceProvider}
                                        rejectServiceProvider={rejectServiceProvider}
                                        approveServiceProvider={approveServiceProvider}
                                    />
                                ))
                            }
                        </div>
                    </div>
                    <ServiceProvidersHistoryDialog
                        open={openHistoryDialog}
                        toggle={this.toggleHistoryDialog}
                    />
                </div>
                
            </Fragment>
        );
    }
}

ServiceProviders.propTypes = {
    port: PropTypes.object,
};

ServiceProviders.defaultProps = {
    port: {},
};

export default connect(
    (state, { serviceProviders, rejectServiceProvider, approveServiceProvider }) => ({
        serviceProviders,
        rejectServiceProvider,
        approveServiceProvider,
    }),
    dispatch => bindActionCreators({

    }, dispatch),
)(ServiceProviders);



// WEBPACK FOOTER //
// ./app/components/Regions/PortApprove/ServiceProviders/Component.jsx